{
  "name": "@klareospace/pharos-ui-frontoffice",
  "version": "2.1.0",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "eslint src/",
    "typecheck": "tsc --noEmit",
    "unit-test": "vitest run",
    "unit-test:coverage": "vitest run --coverage",
    "integration-test": "echo 0"
  },
  "dependencies": {
    "@azure/web-pubsub-client": "^1.1.0",
    "@hookform/resolvers": "^5.2.2",
    "@klareospace/pharos-lib-front-utils": "workspace:*",
    "@klareospace/pharos-lib-types": "workspace:*",
    "@klareospace/pharos-lib-utils": "workspace:*",
    "@klareospace/pharos-lib-web-utils": "workspace:*",
    "@tanstack/react-query": "^5.104.1",
    "@tanstack/react-router": "^1.170.41",
    "altcha": "^2.3.0",
    "axios": "^1.20.0",
    "firebase": "^11.10.0",
    "i18next": "^26.4.2",
    "i18next-browser-languagedetector": "^8.2.1",
    "leaflet": "^1.9.4",
    "lucide-react": "^0.577.0",
    "react": "19.3.0",
    "react-dom": "19.3.0",
    "react-hook-form": "^7.71.2",
    "react-i18next": "^17.0.15",
    "react-leaflet": "^5.0.0",
    "zod": "^4.6.5"
  },
  "lint-staged": {
    "src/**/*.{ts,tsx}": [
      "eslint"
    ],
    "*": "prettier --check --ignore-unknown --ignore-path ../../.prettierignore"
  },
  "devDependencies": {
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/router-plugin": "^1.168.42",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^6.10.0",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.7",
    "@types/leaflet": "^1.9.22",
    "@types/react": "~19.3.0",
    "@types/react-dom": "~19.3.0",
    "@vitejs/plugin-react": "^6.1.1",
    "@vitest/coverage-v8": "^4.1.11",
    "jsdom": "^25.0.1",
    "msw": "^2.15.0",
    "tailwindcss": "^4.3.3",
    "vite": "^8.3.2",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.1.11"
  }
}
